import { FirebaseApp, initializeApp } from "firebase/app";
import {
  Auth,
  browserLocalPersistence,
  browserSessionPersistence,
  getAuth,
  indexedDBLocalPersistence,
  initializeAuth,
} from "firebase/auth";

// Firebase client app initialization using environment variables
// CRA requires REACT_APP_ prefix for env vars. Values below fall back to
// the provided project configuration if env vars are missing.
const firebaseConfig = {
  apiKey: (process.env["REACT_APP_FIREBASE_API_KEY"] as string) ?? "AIzaSyCebOuEoLLS7HmnC6O90U1a50tlPnsB_PI",
  authDomain: (process.env["REACT_APP_FIREBASE_AUTH_DOMAIN"] as string) ?? "golden-harvest-a99f5.firebaseapp.com",
  projectId: (process.env["REACT_APP_FIREBASE_PROJECT_ID"] as string) ?? "golden-harvest-a99f5",
  storageBucket: (process.env["REACT_APP_FIREBASE_STORAGE_BUCKET"] as string) ?? "golden-harvest-a99f5.firebasestorage.app",
  messagingSenderId: (process.env["REACT_APP_FIREBASE_MESSAGING_SENDER_ID"] as string) ?? "723347109811",
  appId: (process.env["REACT_APP_FIREBASE_APP_ID"] as string) ?? "1:723347109811:web:2688c962f6c1b445ef3dc6",
};

let appInstance: FirebaseApp | null = null;

export function getFirebaseApp(): FirebaseApp {
  if (appInstance) return appInstance;
  appInstance = initializeApp(firebaseConfig);
  return appInstance;
}



let authInstance: Auth | null = null;

/**
 * Shared Firebase Auth instance. The app only uses email/password, so this is
 * initialised without a popup/redirect resolver (same persistence order as getAuth's
 * default). That avoids loading Firebase's cross-origin auth iframe on every page view.
 * If a Google/OAuth popup login is ever added, pass `popupRedirectResolver:
 * browserPopupRedirectResolver` here.
 */
export function getFirebaseAuth(): Auth {
  if (authInstance) return authInstance;
  const app = getFirebaseApp();
  try {
    authInstance = initializeAuth(app, {
      persistence: [indexedDBLocalPersistence, browserLocalPersistence, browserSessionPersistence],
    });
  } catch {
    // Already initialised elsewhere (e.g. hot reload): reuse that instance.
    authInstance = getAuth(app);
  }
  return authInstance;
}
